import React from 'react';
import Selector from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withFormsyValidations from '../withFormsyValidations';

function Select(props) {
  Select.propTypes = {
    instanceId: PropTypes.string,
    name: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    errorMessage: PropTypes.string,
    isValid: PropTypes.bool.isRequired,
    setValue: PropTypes.func.isRequired,
    required: PropTypes.bool,
    filterOn: PropTypes.func,
    isClearable: PropTypes.bool,
    isMulti: PropTypes.bool,
    placeholder: PropTypes.string,
  };

  Select.defaultProps = {
    isDisabled: false,
    value: '',
    errorMessage: '',
    placeholder: 'Skriv för att söka ...',
    instanceId: undefined,
    filterOn: undefined,
    required: false,
    isClearable: false,
    isMulti: false,
  };

  const {
    instanceId,
    name,
    isDisabled,
    options,
    setValue,
    onChange,
    filterOn,
    isMulti,
  } = props;

  function handleSelectChange(selectorOption) {
    const value = isMulti
      ? selectorOption.map(option => option.value)
      : _.get(selectorOption, 'value', '<NULL>');
    setValue(value);
    onChange(name, value, selectorOption);
  }

  const filteredOptions = filterOn ? options.filter(filterOn) : options;

  const { value, isValid, required, isClearable, placeholder, ...extras } =
    props;
  const selectedValue = isMulti
    ? options.filter(x => value.includes(x.value))
    : options.filter(x => x.value === value);
  const selectorOptions =
    required || isMulti
      ? [...filteredOptions]
      : [{ label: '(Blankt)', value: '<NULL>' }, ...filteredOptions];
  return (
    <Selector
      {...extras}
      className={!isValid ? 'border border-danger' : ''}
      instanceId={instanceId}
      name={name}
      isDisabled={isDisabled}
      value={selectedValue}
      onChange={handleSelectChange}
      options={selectorOptions}
      isClearable={isClearable}
      placeholder={placeholder}
    />
  );
}

export default withFormsyValidations(Select, props => ({
  requiredValidation(values, value) {
    if (props.required) {
      return !!value && !(_.isObject(value) && _.isEmpty(value));
    }
    return true;
  },
}));
